import { forEach, map } from "lodash";
import { DirectConnectionType } from "./DirectConnectionType";
import type { IAvailableChannel } from "./IAvailableChannel";
import { EquipmentFunctionalityClass } from "./EquipmentFunctionalityClass";
import type { IEquipmentFunctionalityType } from "./IEquipmentFunctionalityType";
import type { IEquipmentFunctionalityTypeSlim } from "./IEquipmentFunctionalityTypeSlim";
import { ResolutionMode } from "./ResolutionMode";

export class EquipmentFunctionalityTypeFunctions {
    public static enhanceFunctionalityTypeSlim(ft: IEquipmentFunctionalityTypeSlim): IEquipmentFunctionalityTypeSlim {
        ft.className = ft.class as any as keyof typeof EquipmentFunctionalityClass;
        ft.class = EquipmentFunctionalityClass[ft.className];
        ft.displayName = `${ft.manufacturer.name} - ${ft.model}${ft.version ? ` ${ft.version}` : ""}`;
        return ft;
    }

    public static enhanceFunctionalityType(ft: IEquipmentFunctionalityType): IEquipmentFunctionalityType {
        const functionalityType = EquipmentFunctionalityTypeFunctions.enhanceFunctionalityTypeSlim(
            ft,
        ) as IEquipmentFunctionalityType;

        if (functionalityType.supportedResolutionModes) {
            functionalityType.supportedResolutionModes = functionalityType.supportedResolutionModes.map(
                (rm) => ResolutionMode[rm as any as keyof typeof ResolutionMode],
            );
        }

        forEach(functionalityType.availableChannels, (channel: IAvailableChannel) => {
            channel.supportedDirectConnections = map(
                channel.supportedDirectConnections,
                (connection) => DirectConnectionType[connection as unknown as keyof typeof DirectConnectionType],
            );
        });

        return ft;
    }
}
